import { StyledUnderlineButton } from '@/components/VehicleSearchForm/components';
import { Icons, Stack, Text } from '@/theme/index';

interface HiddenSectionProps {
  name: string;
  id: string;
  hasUnhidden: boolean;
  isLoading: boolean;
  handleOnUnhide: () => void;
  isNested?: boolean;
}

export const HiddenSection = ({
  name,
  id,
  hasUnhidden,
  isLoading,
  handleOnUnhide,
  isNested,
}: HiddenSectionProps) => {
  if (hasUnhidden) {
    return null;
  }

  const determineVerbForm = (name: string) => {
    return name.endsWith('s') && !name.endsWith('ss') ? 'are' : 'is';
  };

  return (
    <Stack
      alignItems="start"
      id={id}
      px={{ xs: 1, md: 2 }}
      mb={isNested ? 0 : 2}
      direction={{ xs: 'column', md: 'row' }}
      spacing={{ xs: 0.75, md: 2 }}
      justifyContent="space-between"
      sx={{ backgroundColor: '#eeeeee' }}
    >
      <Stack direction="row" alignItems="center">
        <Icons.VisibilityOffRounded
          fontSize="small"
          className="hidden-section-icon"
          sx={{ mr: 1 }}
        />
        <Text variant="body1" color="text.secondary">
          {name} {determineVerbForm(name)} currently hidden
        </Text>
      </Stack>
      <StyledUnderlineButton
        color="primary"
        onClick={handleOnUnhide}
        disabled={isLoading}
      >
        Unhide Section
      </StyledUnderlineButton>
    </Stack>
  );
};
